const vehicleStatusColors = {
  MOV: '#289FE6',
  ON: '#0DC390',
  CHA: '#FF812E',
  OFF: '#999999',
  BAD: '#F60141',
};

const vehicleStatusColorsInChart = {
  MOV: '#5B8FF9',
  ON: '#5B8FF9',
  CHA: '#62DAAA',
  OFF: '#5D7092',
  BAD: '#F60141',
};

const vehicleStatusText = {
  MOV: 'En movimiento',
  ON: 'Encendido',
  CHA: 'Cargando',
  OFF: 'Apagado',
  BAD: 'Desconectado',
};

export { vehicleStatusColors, vehicleStatusColorsInChart, vehicleStatusText };
